module.exports = __webpack_public_path__ + "static/matrix_background-43c8e5d7a7559b844f5cfe87878db27a.png";